module.exports = __webpack_public_path__ + "static/img/mood12.b0595a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood12.png
// module id = 5j8A
// module chunks = 1